import {
  ChevronDownLightIcon,
  ChevronUpLightIcon,
} from '@global-engineering-shared/gweb-global-icons';
import { Button, Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import useStyles from 'components/DateTimePicker/components/DateTimePickerButton/DateTimePickerButton.styles';

type DateTimePickerButtonProps = {
  selectedOption: string;
  showOptions: boolean;
  setShowOptions: React.Dispatch<React.SetStateAction<boolean>>;
};

const DateTimePickerButton = ({
  selectedOption,
  showOptions,
  setShowOptions,
}: DateTimePickerButtonProps) => {
  const classes = useStyles();

  return (
    <div className={classes.buttonContainer}>
      <Button
        className={classes.dropdownButton}
        variant="outlined"
        onClick={() => setShowOptions(!showOptions)}
      >
        <Typography className={classes.dropdownButtonText}>{selectedOption}</Typography>
        {!showOptions ? (
          <ChevronDownLightIcon className={classes.icon} />
        ) : (
          <ChevronUpLightIcon className={classes.icon} />
        )}
      </Button>
    </div>
  );
};

export default DateTimePickerButton;
